import { useState } from 'react'
import { Tab } from '@mercai/clever'
import { useParams } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'


import { useCatalogProductDetail, QUERIES_ADMIN } from '@/services'
import { CatalogProductDetail } from './components/detail'
import { CatalogProductProps } from '@/types'

import styles from './show.module.css'
import { Button, ChevronLeftIcon, Text } from '@mercai/clever'
import { ROUTES_ADMIN } from '@/router'
import { useTranslation } from 'react-i18next'
import { DrawerForm } from '../components'
import { SupplierForecastDrawerForm } from '@/components'
import { useParamsState } from '@/helpers'
import { SupplierProductTable } from './components/supplier-product-table'
import { InventoryTable } from './components/inventory-table'

export const ProductShow = () => {
  const { uuid } = useParams()
  const queryClient = useQueryClient()

  const { t } = useTranslation('screenCatalogProduct')

  const [queryParams, setQueryParams] = useParamsState({
    form: '',
    tab: 'agreements',
  })

  const handleEditCatalogProduct = () => {
    setQueryParams({
      form: 'true',
    })
  }

  const { data: catalogProductData, isLoading: catalogProductIsLoading } =
    useCatalogProductDetail(uuid)

  const [isOpenCreateDrawer, setIsOpenCreateDrawer] = useState(false)

  const onCompleteCreate = () => {
    queryClient.invalidateQueries({
      queryKey: [QUERIES_ADMIN.BFF_FORECAST.module],
    })
  }

  return (
    <div className={styles.core}>
      <section className={styles['header-section']}>
        <div className={styles['header-left-sidebar']}>
          <a href={`/${ROUTES_ADMIN.CATALOG.PRODUCT.path}`}>
            <ChevronLeftIcon />
          </a>
          <div>
            <Text>
              <strong>{`${t('title')} / `}</strong>
              <Text>{catalogProductData?.data?.reference}</Text>
            </Text>
            <div className={styles.title}>
              <Text variant="title-large">
                {catalogProductData?.data?.attributes?.title}
              </Text>
            </div>
          </div>
        </div>
        <Button variant="secondary" onClick={() => handleEditCatalogProduct()}>
          {t('detailEditButton')}
        </Button>
      </section>
      <CatalogProductDetail
        catalogProduct={catalogProductData?.data as CatalogProductProps}
        isLoading={catalogProductIsLoading}
      />

      <div className={styles['tabs-container']}>
        <Tab
          items={[
            {
              label: t('tabAgreements'),
              value: 'agreements',
            },
            {
              label: t('tabInventory'),
              value: 'inventory',
            },
          ]}
          value={queryParams.tab || 'agreements'}
          onChange={(value) =>
            setQueryParams({
              ...queryParams,
              tab: value,
            })
          }
        />
        {(!queryParams.tab || queryParams.tab === 'agreements') && (
          <Button
            variant="success-light"
            onClick={() => setIsOpenCreateDrawer(true)}
            size="small"
          >
            {t('detailAddSupplierButton')}
          </Button>
        )}
      </div>

      {(!queryParams.tab || queryParams.tab === 'agreements') && (
        <SupplierProductTable
          uuid={uuid || ''}
        />
      )}

      {queryParams.tab === 'inventory' && <InventoryTable uuid={uuid || ''} />}

      <DrawerForm
        isOpen={!!queryParams.form}
        onHandleOpen={() =>
          setQueryParams({
            form: '',
          })
        }
        catalogProductUuid={uuid}
      />

      <SupplierForecastDrawerForm
        isOpen={isOpenCreateDrawer}
        onHandleOpen={() => setIsOpenCreateDrawer(false)}
        onCompleteCreate={onCompleteCreate}
        catalogProductUuid={uuid}
      />
    </div>
  )
}
